
import {
  socialMediaIconStyles,
} from 'components/Templates/styles/Red/commonObjectsStyles';


import facebookIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_facebook.svg?url';
import linkedinIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_linkedin.svg?url';
import twitterIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_twitter.svg?url';
import instagramIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_instagram.svg?url';
import slackIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_slack.svg?url';


/* eslint-disable */



const thisStyle =  {
  wrapperScroll: {
    '0': {
      'position': 'sticky',
      'top': '50%',
      'z-index': '200',
    }
  },
  wrapper: {
    '0': {
      'width': '3rem',
      'background-color' : '{sectionBackgroundColor}',
      'padding-bottom': '0.5rem',
      'padding-top': '0.5rem',
      'padding-right': '0.5rem',
      'height': 'fit-content',
      'right': '0',
      'position': 'absolute'
    },
  },
  facebookIcon: {
    '0': {
      ...socialMediaIconStyles,
      'width': '3rem',
      'height': '3rem',
      'float': 'left',
      'margin-bottom': '1rem',
      'background-image': `url(${facebookIcon})`,
    },
    '37_5': {
      'margin-bottom': '0',
    }
  },
  linkedinIcon: {
    '0': {
      ...socialMediaIconStyles,
      'width': '3rem',
      'height': '3rem',
      'float': 'left',
      'margin-bottom': '1rem',
      'background-image': `url(${linkedinIcon})`,
    },
    '37_5': {
      'margin-bottom': '0',
    }
  },
  twitterIcon: {
    '0': {
      ...socialMediaIconStyles,
      'width': '3rem',
      'height': '3rem',
      'float': 'left',
      'margin-bottom': '1rem',
      'background-image': `url(${twitterIcon})`,
    },
    '37_5': {
      'margin-bottom': '0',
    }
  },
  instagramIcon: {
    '0': {
      ...socialMediaIconStyles,
      'width': '3rem',
      'height': '3rem',
      'float': 'left',
      'margin-bottom': '1rem',
      'background-image': `url(${instagramIcon})`,
    },
    '37_5': {
      'margin-bottom': '0',
    }
  },
  slackIcon: {
    '0': {
      ...socialMediaIconStyles,
      'width': '3rem',
      'height': '3rem',
      'float': 'left',
      'background-image': `url(${slackIcon})`,
    },
    '37_5': {
      'margin-bottom': '0',
    }
  },
  
}



export default thisStyle;